import { render, staticRenderFns } from "./PermissionTemplate.vue?vue&type=template&id=3e9f73ea&scoped=true&"
import script from "./PermissionTemplate.vue?vue&type=script&lang=js&"
export * from "./PermissionTemplate.vue?vue&type=script&lang=js&"
import style0 from "./PermissionTemplate.vue?vue&type=style&index=0&id=3e9f73ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9f73ea",
  null
  
)

export default component.exports